export interface RoutesI {
  path: string;
  breadcrumb: string;
  categoryId?: number;
}

export const routes: RoutesI[] = [
  {
    path: "/",
    breadcrumb: "ГЛАВНАЯ",
  },
  {
    path: "/policy",
    breadcrumb: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
  },
  {
    path: "/consent",
    breadcrumb: "СОГЛАСИЕ НА ОБРАБОТКУ ДАННЫХ",
  },
  {
    path: "/notification-consent",
    breadcrumb: "СОГЛАСИЕ НА ПОЛУЧЕНИЕ РАССЫЛКИ",
  },
  {
    path: "/blog",
    breadcrumb: "БЛОГ",
  },
  {
    path: "/blog/post",
    breadcrumb: "ПОСТЫ",
  },
  {
    path: "/reviews",
    breadcrumb: "ОТЗЫВЫ",
  },
  {
    path: "/company",
    breadcrumb: "О КОМПАНИИ",
  },
  {
    path: "/services",
    breadcrumb: "УСЛУГИ",
  },
  {
    path: "/services/talkitout",
    breadcrumb: "ВЫГОВОРИТСЯ",
    categoryId: 10,
  },
  {
    path: "/services/career-consult",
    breadcrumb: "КАРЬЕРНАЯ КОНСУЛЬТАЦИЯ",
    categoryId: 2,
  },
  {
    path: "/services/cv-ready",
    breadcrumb: "РЕЗЮМЕ «ПОД КЛЮЧ»",
    categoryId: 1,
  },
  {
    path: "/services/search-support",
    breadcrumb: "ХОЧУ ОФФЕР",
    categoryId: 12,
  },
  {
    path: "/services/probation-support",
    breadcrumb: "ИСПЫТАТЕЛЬНЫЙ СРОК",
    categoryId: 4,
  },
  {
    path: "/services/it-hiring",
    breadcrumb: "ПОДБОР ИТ СПЕЦИАЛИСТОВ",
    categoryId: 13,
  },
  {
    path: "/services/it-training",
    breadcrumb: "ОБУЧЕНИЕ РЕКРУТИНГУ",
    categoryId: 17,
  },
  {
    path: "/services/vacancies",
    breadcrumb: "ПОИСК ВАКАНСИЙ",
    categoryId: 8,
  },
  {
    path: "/services/linkedin-boost",
    breadcrumb: "РАЗВИТИЕ LINKEDIN ПРОФИЛЯ",
    categoryId: 18,
  },
  // TODO для новой страницы
  // {
  //   path: "/services/c-level",
  //   breadcrumb: "ТОП ПРОДВИЖЕНИЕ",
  //   categoryId: 19,
  // },
];
